/* YUBZ discover + growth features: gift finder, compare, drops, reviews, circle, restock, delivery promise.
   No dependencies. Every module boots from a data attribute and reads its copy from data-yb-i18n (Liquid translations). */
(() => {
  if (window.yubzDiscoverReady) return;
  window.yubzDiscoverReady = true;

  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const isArabic = document.documentElement.lang.toLowerCase().startsWith('ar');
  const locale = isArabic ? 'ar-KW' : 'en-KW';
  const handleOK = value => typeof value === 'string' && /^[a-z0-9][a-z0-9-]{0,254}$/.test(value);
  const escapeHTML = value => String(value == null ? '' : value).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const safeImage = value => {
    if (typeof value !== 'string' || !value) return '';
    try { const url = new URL(value, location.origin); return url.protocol === 'https:' && (url.origin === location.origin || url.hostname === 'cdn.shopify.com') ? url.href : ''; } catch { return ''; }
  };
  const i18n = el => { try { return JSON.parse(el.getAttribute('data-yb-i18n') || '{}'); } catch { return {}; } };
  const t = (dict, key, vars) => String(dict[key] || key).replace(/\{\{\s*(\w+)\s*\}\}|\[(\w+)\]/g, (m, a, b) => { const k = a || b; return vars && k in vars ? vars[k] : m; });
  const money = (cents, currency) => {
    const value = Number(cents) / 100;
    try { return new Intl.NumberFormat(locale, { style: 'currency', currency: currency || 'KWD', minimumFractionDigits: 3 }).format(value).replace('KWD', isArabic ? 'د.ك' : 'KD'); } catch { return value.toFixed(3) + (isArabic ? ' د.ك' : ' KD'); }
  };
  const fmtNumber = n => { try { return new Intl.NumberFormat(locale).format(n); } catch { return String(n); } };
  const storage = {
    get(key, fallback) { try { const v = JSON.parse(localStorage.getItem(key)); return v == null ? fallback : v; } catch { return fallback; } },
    set(key, value) { try { localStorage.setItem(key, JSON.stringify(value)); return true; } catch { return false; } }
  };
  const postJSON = async (path, body) => {
    const response = await fetch(root.replace(/\/$/, '') + path, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
    let data = null; try { data = await response.json(); } catch { /* empty body is fine */ }
    return { ok: response.ok, status: response.status, data };
  };
  const setStatus = (node, text, tone) => { if (!node) return; node.textContent = text || ''; if (tone) node.dataset.tone = tone; else delete node.dataset.tone; };
  const fetchSection = async (url, sectionId) => {
    const target = new URL(url, location.origin);
    target.searchParams.set('section_id', sectionId);
    const response = await fetch(target.href, { credentials: 'same-origin' });
    if (!response.ok) throw new Error('section ' + response.status);
    const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
    return doc.getElementById('shopify-section-' + sectionId) || doc.body;
  };

  /* ---------------- Gift finder ---------------- */
  function giftFinder(rootEl) {
    if (rootEl.dataset.ybBooted) return; rootEl.dataset.ybBooted = '1';
    const dict = i18n(rootEl);
    const steps = [...rootEl.querySelectorAll('[data-yb-gf-step]')];
    const results = rootEl.querySelector('[data-yb-gf-results]');
    const grid = rootEl.querySelector('[data-yb-gf-grid]');
    const status = rootEl.querySelector('[data-yb-gf-status]');
    const bar = rootEl.querySelector('[data-yb-gf-bar]');
    const stepLabel = rootEl.querySelector('[data-yb-gf-step-label]');
    const answersBox = rootEl.querySelector('[data-yb-gf-answers]');
    const openLink = rootEl.querySelector('[data-yb-gf-open]');
    const base = rootEl.dataset.base || root + 'collections/all';
    const sectionId = rootEl.dataset.resultsSection || 'yubz-discover-results';
    const answers = {};
    let index = 0;

    const visibleSteps = () => steps.filter(step => {
      if (step.dataset.ybGfStep !== 'age') return true;
      return !(answers.who === 'teen' || answers.who === 'adult' || answers.who === 'parent');
    });
    const show = i => {
      const list = visibleSteps();
      index = Math.max(0, Math.min(i, list.length - 1));
      steps.forEach(step => delete step.dataset.active);
      results && delete results.dataset.active;
      const step = list[index];
      step.dataset.active = '1';
      if (step.dataset.ybGfStep === 'age') {
        step.querySelectorAll('[data-yb-gf-opt]').forEach(opt => { const forWho = (opt.dataset.for || '').split(','); opt.hidden = !!answers.who && !forWho.includes(answers.who); });
      }
      if (bar) bar.style.width = Math.round(((index + 1) / (list.length + 1)) * 100) + '%';
      if (stepLabel) stepLabel.textContent = t(dict, 'step', { current: index + 1, total: list.length });
      step.querySelector('h2')?.focus?.();
    };
    const finish = async () => {
      steps.forEach(step => delete step.dataset.active);
      if (bar) bar.style.width = '100%';
      if (results) results.dataset.active = '1';
      const params = new URLSearchParams();
      if (answers.who === 'teen') answers.age = 'teen';
      if (answers.who === 'adult' || answers.who === 'parent') answers.age = 'adult';
      if (answers.age && answers.age !== 'any') params.append('filter.p.tag', 'age:' + answers.age);
      if (answers.interest && answers.interest !== 'any') params.append('filter.p.tag', 'interest:' + answers.interest);
      if (answers.who === 'parent') params.append('filter.p.tag', 'occasion:new-baby');
      if (answers.budget && answers.budget !== 'any') {
        const [min, max] = answers.budget.split('-');
        if (min) params.set('filter.v.price.gte', min);
        if (max) params.set('filter.v.price.lte', max);
      }
      const url = base + (params.toString() ? '?' + params.toString() : '');
      if (openLink) openLink.href = url;
      if (answersBox) {
        answersBox.innerHTML = '';
        ['who', 'age', 'interest', 'budget'].forEach(q => {
          const btn = rootEl.querySelector(`[data-yb-gf-opt][data-q="${q}"][data-value="${CSS.escape(answers[q] || '')}"]`);
          if (!btn) return;
          const chip = document.createElement('button'); chip.type = 'button'; chip.className = 'yb-d__chip'; chip.setAttribute('aria-pressed', 'true');
          chip.textContent = btn.querySelector('span')?.textContent || btn.textContent.trim();
          chip.addEventListener('click', () => { const list = visibleSteps(); const i = list.findIndex(s => s.dataset.ybGfStep === q); show(i < 0 ? 0 : i); });
          answersBox.append(chip);
        });
      }
      setStatus(status, t(dict, 'loading'));
      if (grid) grid.innerHTML = '';
      try {
        const section = await fetchSection(url, sectionId);
        const inner = section.querySelector('[data-yb-results]') || section;
        if (grid) grid.innerHTML = inner.innerHTML;
        const count = grid ? grid.querySelectorAll('[data-yb-card]').length : 0;
        setStatus(status, '');
        if (!count && grid && !grid.textContent.trim()) setStatus(status, t(dict, 'empty'), 'error');
      } catch {
        setStatus(status, t(dict, 'error'), 'error');
      }
    };
    rootEl.addEventListener('click', e => {
      const opt = e.target.closest('[data-yb-gf-opt]');
      if (opt) {
        answers[opt.dataset.q] = opt.dataset.value;
        opt.closest('[data-yb-gf-step]').querySelectorAll('[data-yb-gf-opt]').forEach(o => o.setAttribute('aria-pressed', String(o === opt)));
        const list = visibleSteps();
        if (index >= list.length - 1) finish(); else show(index + 1);
        return;
      }
      if (e.target.closest('[data-yb-gf-back]')) { show(index - 1); return; }
      if (e.target.closest('[data-yb-gf-restart]')) { Object.keys(answers).forEach(k => delete answers[k]); rootEl.querySelectorAll('[data-yb-gf-opt]').forEach(o => o.setAttribute('aria-pressed', 'false')); show(0); return; }
      if (e.target.closest('[data-yb-gf-retry]')) { finish(); }
    });
    show(0);
  }

  /* ---------------- Compare ---------------- */
  const compare = (() => {
    const KEY = 'yubz-compare-v2', MAX = 4;
    let dict = {};
    const read = () => { const list = storage.get(KEY, []); return Array.isArray(list) ? list.filter(item => item && handleOK(item.handle)).slice(0, MAX) : []; };
    const write = list => { storage.set(KEY, list); render(); document.dispatchEvent(new CustomEvent('yubz:compare-change', { detail: { items: list } })); };
    const has = handle => read().some(item => item.handle === handle);
    let toast;
    const announce = text => {
      if (!toast) { toast = document.createElement('div'); toast.className = 'yb-tools-status yb-d__sr'; toast.setAttribute('role', 'status'); toast.setAttribute('aria-live', 'polite'); document.body.append(toast); }
      toast.textContent = text; clearTimeout(announce.timer); announce.timer = setTimeout(() => { toast.textContent = ''; }, 4000);
    };
    const toggle = item => {
      const list = read();
      const i = list.findIndex(x => x.handle === item.handle);
      if (i >= 0) { list.splice(i, 1); write(list); announce(t(dict, 'removed')); return false; }
      if (list.length >= MAX) { announce(t(dict, 'limit')); drawer(true); return null; }
      list.push({ handle: item.handle, title: String(item.title || '').slice(0, 200), image: safeImage(item.image) });
      write(list); announce(t(dict, 'added')); drawer(true); return true;
    };
    let drawerEl;
    const drawer = open => {
      if (!drawerEl) {
        drawerEl = document.createElement('aside');
        drawerEl.className = 'yb-cmp-drawer'; drawerEl.setAttribute('aria-label', t(dict, 'drawer_title'));
        drawerEl.dataset.ybCompareDrawer = '';
        drawerEl.innerHTML = `<div class="yb-cmp-drawer__items" data-yb-cmp-items></div><span class="yb-cmp-drawer__count" data-yb-cmp-count></span><a class="yb-d__btn yb-d__btn--small" data-yb-cmp-open href="${escapeHTML(dict.page_url || root + 'pages/compare')}">${escapeHTML(t(dict, 'open'))}</a><button type="button" class="yb-cmp-drawer__clear" data-yb-cmp-clear>${escapeHTML(t(dict, 'clear'))}</button>`;
        document.body.append(drawerEl);
        drawerEl.addEventListener('click', e => {
          const rm = e.target.closest('[data-yb-cmp-remove]');
          if (rm) { write(read().filter(x => x.handle !== rm.dataset.ybCmpRemove)); announce(t(dict, 'removed')); }
          if (e.target.closest('[data-yb-cmp-clear]')) { write([]); }
        });
      }
      if (open != null) drawerEl.dataset.open = String(open && read().length > 0);
      return drawerEl;
    };
    const render = () => {
      const list = read();
      document.querySelectorAll('[data-yb-cmp-add]').forEach(btn => {
        const active = has(btn.dataset.handle);
        btn.setAttribute('aria-pressed', String(active));
        const label = btn.querySelector('[data-yb-cmp-label]'); if (label) label.textContent = active ? t(dict, 'remove') : t(dict, 'add');
      });
      document.querySelectorAll('[data-yb-compare-count]').forEach(n => { n.textContent = String(list.length); });
      if (!drawerEl && !list.length) return;
      const el = drawer();
      const items = el.querySelector('[data-yb-cmp-items]');
      items.innerHTML = list.map(item => `<span class="yb-cmp-drawer__item" title="${escapeHTML(item.title)}">${item.image ? `<img src="${escapeHTML(item.image)}" alt="" loading="lazy" width="48" height="48">` : ''}<button type="button" data-yb-cmp-remove="${escapeHTML(item.handle)}" aria-label="${escapeHTML(t(dict, 'remove_item'))}: ${escapeHTML(item.title)}">×</button></span>`).join('') + '<span class="yb-cmp-drawer__slot" aria-hidden="true"></span>'.repeat(Math.max(0, MAX - list.length));
      el.querySelector('[data-yb-cmp-count]').textContent = t(dict, 'count', { count: list.length });
      el.querySelector('[data-yb-cmp-open]').toggleAttribute('disabled', list.length < 2);
      if (document.querySelector('[data-yb-cmp-page]')) el.dataset.open = 'false';
      else if (!list.length) el.dataset.open = 'false';
      else if (el.dataset.open !== 'false' || list.length) el.dataset.open = 'true';
    };
    const bootButtons = () => {
      document.querySelectorAll('[data-yb-cmp-add]').forEach(btn => {
        if (btn.dataset.ybBooted) return; btn.dataset.ybBooted = '1';
        if (!Object.keys(dict).length) dict = i18n(btn);
        btn.hidden = false;
      });
      render();
    };
    document.addEventListener('click', e => {
      const btn = e.target.closest('[data-yb-cmp-add]');
      if (!btn) return;
      e.preventDefault();
      dict = { ...i18n(btn), ...dict };
      toggle({ handle: btn.dataset.handle, title: btn.dataset.title, image: btn.dataset.image });
    });
    addEventListener('storage', e => { if (e.key === KEY) render(); });

    /* Compare page */
    async function page(el) {
      if (el.dataset.ybBooted) return; el.dataset.ybBooted = '1';
      dict = { ...dict, ...i18n(el) };
      const currency = el.dataset.currency || 'KWD';
      const specsSection = el.dataset.specsSection || 'yubz-discover-specs';
      const wrap = el.querySelector('[data-yb-cmp-table]');
      const empty = el.querySelector('[data-yb-cmp-empty]');
      const status = el.querySelector('[data-yb-cmp-status]');
      const onlyDiff = el.querySelector('[data-yb-cmp-diff]');
      const cache = new Map();
      const load = async handle => {
        if (cache.has(handle)) return cache.get(handle);
        const job = (async () => {
          const product = await fetch(`${root}products/${encodeURIComponent(handle)}.js`, { headers: { Accept: 'application/json' }, credentials: 'same-origin' }).then(r => r.ok ? r.json() : null).catch(() => null);
          if (!product) return null;
          let specs = {};
          try {
            const section = await fetchSection(`${root}products/${encodeURIComponent(handle)}`, specsSection);
            const json = section.querySelector('[data-yb-specs]');
            if (json) specs = JSON.parse(json.textContent || '{}');
          } catch { /* specs are optional */ }
          return { product, specs };
        })();
        cache.set(handle, job);
        return job;
      };
      const rowsFor = items => {
        const rows = [];
        const add = (label, values, kind) => rows.push({ label, values, kind });
        add(t(dict, 'price'), items.map(({ product }) => product.price_varies ? `${t(dict, 'from') || ''} ${money(product.price_min, currency)}`.trim() : money(product.price, currency)), 'price');
        add(t(dict, 'brand'), items.map(({ product }) => product.vendor || ''));
        add(t(dict, 'availability'), items.map(({ product }) => product.available ? 'yes' : 'no'), 'bool');
        const specKeys = [...new Set(items.flatMap(({ specs }) => Object.keys(specs)))];
        specKeys.forEach(key => add(items.find(({ specs }) => specs[key])?.specs[key]?.label || key.replace(/_/g, ' '), items.map(({ specs }) => specs[key] ? specs[key].value : '')));
        if (!specKeys.length) {
          const optionNames = [...new Set(items.flatMap(({ product }) => (product.options || []).map(o => o.name)))].filter(name => name && name.toLowerCase() !== 'title');
          optionNames.forEach(name => add(name, items.map(({ product }) => { const opt = (product.options || []).find(o => o.name === name); return opt ? opt.values.join(', ') : ''; })));
        }
        const ageOf = product => (product.tags || []).filter(tag => /^age:/.test(tag)).map(tag => tag.slice(4)).join(', ');
        if (items.some(({ product }) => ageOf(product))) add(dict.age_label || 'Age', items.map(({ product }) => ageOf(product)));
        const highlights = product => (product.tags || []).filter(tag => !/^(age|interest|occasion|character|world|dept|subdept|budget):/.test(tag)).slice(0, 6).join(' · ');
        if (items.some(({ product }) => highlights(product))) add(t(dict, 'tags'), items.map(({ product }) => highlights(product)));
        return rows;
      };
      const draw = async () => {
        const list = read();
        if (!list.length) { wrap.innerHTML = ''; empty.hidden = false; setStatus(status, ''); return; }
        empty.hidden = true;
        setStatus(status, t(dict, 'loading'));
        const loaded = await Promise.all(list.map(item => load(item.handle)));
        const items = loaded.filter(Boolean);
        setStatus(status, loaded.length !== items.length ? t(dict, 'error') : '', loaded.length !== items.length ? 'error' : '');
        if (!items.length) { wrap.innerHTML = ''; return; }
        const rows = rowsFor(items);
        const head = items.map(({ product }) => {
          const image = product.featured_image ? safeImage(product.featured_image.replace(/(\.[a-z]+)(\?.*)?$/i, '_400x$1')) : '';
          return `<th scope="col"><div class="yb-cmp__head">${image ? `<img src="${escapeHTML(image)}" alt="" width="120" height="120" loading="lazy">` : ''}<a href="${root}products/${encodeURIComponent(product.handle)}">${escapeHTML(product.title)}</a><button type="button" data-yb-cmp-remove-page="${escapeHTML(product.handle)}">${escapeHTML(t(dict, 'remove_item'))}</button></div></th>`;
        }).join('');
        const body = rows.map(row => {
          const values = row.values.map(v => String(v ?? '').trim());
          const diff = new Set(values.map(v => v.toLowerCase())).size > 1;
          const cells = values.map(v => {
            if (row.kind === 'bool') return `<td>${v === 'yes' ? `<span class="yb-cmp__yes">${escapeHTML(t(dict, 'in_stock'))}</span>` : `<span class="yb-cmp__no">${escapeHTML(t(dict, 'sold_out'))}</span>`}</td>`;
            if (row.kind === 'price') return `<td><span class="yb-cmp__price">${escapeHTML(v)}</span></td>`;
            return `<td>${v ? escapeHTML(v) : `<span class="yb-d__muted">${escapeHTML(t(dict, 'not_listed'))}</span>`}</td>`;
          }).join('');
          return `<tr data-diff="${diff}"><th scope="row">${escapeHTML(row.label)}</th>${cells}</tr>`;
        }).join('');
        wrap.innerHTML = `<div class="yb-cmp__scroll" tabindex="0"><table class="yb-cmp__table" data-only-diff="${onlyDiff?.checked ? 'true' : 'false'}"><thead><tr><th scope="col">${escapeHTML(t(dict, 'product'))}</th>${head}</tr></thead><tbody>${body}</tbody></table></div>`;
      };
      el.addEventListener('click', e => {
        const rm = e.target.closest('[data-yb-cmp-remove-page]');
        if (rm) { write(read().filter(x => x.handle !== rm.dataset.ybCmpRemovePage)); }
        if (e.target.closest('[data-yb-cmp-clear-page]')) write([]);
      });
      onlyDiff?.addEventListener('change', () => { const table = wrap.querySelector('table'); if (table) table.dataset.onlyDiff = String(onlyDiff.checked); });
      document.addEventListener('yubz:compare-change', draw);
      addEventListener('storage', e => { if (e.key === KEY) draw(); });
      draw();
    }
    return { bootButtons, page, render };
  })();

  /* ---------------- Drops ---------------- */
  function drops(rootEl) {
    if (rootEl.dataset.ybBooted) return; rootEl.dataset.ybBooted = '1';
    const dict = i18n(rootEl);
    const cards = [...rootEl.querySelectorAll('[data-yb-drop]')];
    const pad = n => String(n).padStart(2, '0');
    const tick = () => {
      const now = Date.now();
      cards.forEach(card => {
        const starts = Date.parse(card.dataset.starts || '');
        const ends = card.dataset.ends ? Date.parse(card.dataset.ends) : NaN;
        if (Number.isNaN(starts)) return;
        let state = now < starts ? 'upcoming' : (!Number.isNaN(ends) && now > ends ? 'ended' : 'live');
        if (card.dataset.state !== state) {
          card.dataset.state = state;
          const flag = card.querySelector('[data-yb-drop-state]'); if (flag) flag.textContent = t(dict, state);
          card.querySelectorAll('[data-yb-when-upcoming]').forEach(n => { n.hidden = state !== 'upcoming'; });
          card.querySelectorAll('[data-yb-when-live]').forEach(n => { n.hidden = state !== 'live'; });
        }
        const cd = card.querySelector('[data-yb-cd]');
        if (cd && state === 'upcoming') {
          let diff = Math.max(0, Math.floor((starts - now) / 1000));
          const d = Math.floor(diff / 86400); diff -= d * 86400;
          const h = Math.floor(diff / 3600); diff -= h * 3600;
          const m = Math.floor(diff / 60); const s = diff - m * 60;
          const set = (k, v) => { const n = cd.querySelector(`[data-yb-cd-${k}]`); if (n && n.textContent !== v) n.textContent = v; };
          set('d', String(d)); set('h', pad(h)); set('m', pad(m)); set('s', pad(s));
        }
      });
    };
    tick(); const timer = setInterval(tick, 1000);
    document.addEventListener('shopify:section:unload', e => { if (e.target.contains(rootEl)) clearInterval(timer); });
    rootEl.addEventListener('click', async e => {
      const btn = e.target.closest('[data-yb-notify]');
      if (!btn) return;
      const status = btn.closest('[data-yb-drop]')?.querySelector('[data-yb-notify-status]');
      btn.disabled = true; const label = btn.textContent; btn.textContent = t(dict, 'notifying');
      try {
        const res = await postJSON('/apps/market/notify', { product_id: Number(btn.dataset.productId), kind: 'drop' });
        if (res.ok) { setStatus(status, t(dict, 'notified'), 'ok'); btn.textContent = label; btn.setAttribute('aria-pressed', 'true'); }
        else if (res.status === 401 || res.status === 403) { setStatus(status, t(dict, 'notify_login'), 'error'); btn.disabled = false; btn.textContent = label; }
        else throw new Error('notify');
      } catch { setStatus(status, t(dict, 'notify_error'), 'error'); btn.disabled = false; btn.textContent = label; }
    });
  }

  /* ---------------- Reviews & Q&A ---------------- */
  function reviews(rootEl) {
    if (rootEl.dataset.ybBooted) return; rootEl.dataset.ybBooted = '1';
    const dict = i18n(rootEl);
    rootEl.addEventListener('click', e => {
      const star = e.target.closest('[data-yb-star]');
      if (star) {
        const box = star.closest('[data-yb-star-input]');
        const value = Number(star.dataset.ybStar);
        box.querySelector('input[name="rating"]').value = String(value);
        box.querySelectorAll('[data-yb-star]').forEach(b => { b.toggleAttribute('data-on', Number(b.dataset.ybStar) <= value); b.setAttribute('aria-checked', String(Number(b.dataset.ybStar) === value)); });
        return;
      }
      const opener = e.target.closest('[data-yb-open-form]');
      if (opener) { const form = rootEl.querySelector(`[data-yb-form="${CSS.escape(opener.dataset.ybOpenForm)}"]`); if (form) { form.hidden = !form.hidden; if (!form.hidden) form.querySelector('input,textarea,button')?.focus(); } return; }
      const more = e.target.closest('[data-yb-show-more]');
      if (more) { const list = more.previousElementSibling; list.querySelectorAll('[hidden]').forEach(n => { n.hidden = false; }); more.hidden = true; }
    });
    rootEl.querySelectorAll('form[data-yb-form]').forEach(form => {
      form.addEventListener('submit', async e => {
        e.preventDefault();
        const kind = form.dataset.ybForm;
        const status = form.querySelector('[data-yb-form-status]');
        const submit = form.querySelector('button[type="submit"]');
        const body = Object.fromEntries(new FormData(form).entries());
        body.product_id = Number(form.dataset.productId);
        if (kind === 'review') { body.rating = Number(body.rating); if (!body.rating) { setStatus(status, t(dict, 'rating'), 'error'); return; } }
        submit.disabled = true; const label = submit.textContent; submit.textContent = t(dict, 'sending');
        try {
          const res = await postJSON(kind === 'review' ? '/apps/market/reviews' : '/apps/market/questions', body);
          if (!res.ok) throw new Error('post');
          setStatus(status, t(dict, kind === 'review' ? 'thanks' : 'ask_thanks'), 'ok');
          form.reset(); form.querySelectorAll('[data-yb-star]').forEach(b => b.removeAttribute('data-on'));
        } catch { setStatus(status, t(dict, kind === 'review' ? 'error' : 'ask_error'), 'error'); }
        submit.disabled = false; submit.textContent = label;
      });
    });
  }

  /* ---------------- Circle ---------------- */
  function circleCalc(el) {
    if (el.dataset.ybBooted) return; el.dataset.ybBooted = '1';
    const ppk = Number(el.dataset.ppk) || 10, redeem = Number(el.dataset.redeem) || 100;
    const range = el.querySelector('input[type="range"]');
    const spend = el.querySelector('[data-yb-calc-spend]'), points = el.querySelector('[data-yb-calc-points]'), worth = el.querySelector('[data-yb-calc-worth]');
    const dict = i18n(el);
    const update = () => {
      const kd = Number(range.value);
      const pts = Math.round(kd * ppk);
      if (spend) spend.textContent = fmtNumber(kd) + (isArabic ? ' د.ك' : ' KD');
      if (points) points.textContent = fmtNumber(pts);
      if (worth) worth.textContent = t(dict, 'calc_worth', { value: (pts / redeem).toFixed(3) });
    };
    range.addEventListener('input', update); update();
  }
  async function circleBadge(el) {
    if (el.dataset.ybBooted) return; el.dataset.ybBooted = '1';
    const dict = i18n(el);
    const redeem = Number(el.dataset.redeem) || 100;
    const balance = el.querySelector('[data-yb-badge-balance]'), sub = el.querySelector('[data-yb-badge-sub]');
    try {
      const response = await fetch(root.replace(/\/$/, '') + '/apps/market/me/points', { credentials: 'same-origin', headers: { Accept: 'application/json' } });
      if (response.status === 401 || response.status === 403) { balance.textContent = ''; sub.textContent = t(dict, 'badge_login'); return; }
      if (!response.ok) throw new Error('points');
      const data = await response.json();
      const pts = Number(data.points ?? data.balance ?? 0);
      balance.textContent = t(dict, 'badge_balance', { points: fmtNumber(pts) });
      sub.textContent = data.tier ? String(data.tier) : t(dict, 'badge_worth', { value: (pts / redeem).toFixed(3) });
    } catch { balance.textContent = ''; sub.textContent = t(dict, 'badge_error'); }
  }

  /* ---------------- Restock alert ---------------- */
  function restock(el) {
    if (el.dataset.ybBooted) return; el.dataset.ybBooted = '1';
    const dict = i18n(el);
    let availability = {}; try { availability = JSON.parse(el.dataset.variants || '{}'); } catch { /* keep empty */ }
    const input = el.querySelector('input[name="variant_id"]');
    const status = el.querySelector('[data-yb-restock-status]');
    const form = el.querySelector('form');
    const apply = variantId => {
      if (!variantId) return;
      input.value = String(variantId);
      el.hidden = availability[variantId] !== false;
    };
    apply(el.dataset.current);
    const readForm = () => { const section = el.closest('.shopify-section') || document; const picked = section.querySelector('form[action*="/cart/add"] [name="id"]'); if (picked) apply(picked.value); };
    document.addEventListener('change', e => { if (e.target.closest('variant-selects, variant-radios, .product-form__input, form[action*="/cart/add"]')) setTimeout(readForm, 50); });
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) subscribe(PUB_SUB_EVENTS.variantChange, e => { const v = e?.data?.variant; if (v) { availability[v.id] = !!v.available; apply(v.id); } });
    form.addEventListener('submit', async e => {
      e.preventDefault();
      const email = form.querySelector('input[type="email"]').value.trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { setStatus(status, t(dict, 'invalid'), 'error'); return; }
      const submit = form.querySelector('button'); submit.disabled = true; const label = submit.textContent; submit.textContent = t(dict, 'sending');
      try {
        const res = await postJSON('/apps/market/notify', { variant_id: Number(input.value), email, kind: 'restock' });
        if (!res.ok) throw new Error('restock');
        setStatus(status, t(dict, 'done'), 'ok'); form.reset();
      } catch { setStatus(status, t(dict, 'error'), 'error'); }
      submit.disabled = false; submit.textContent = label;
    });
  }

  /* ---------------- Delivery promise ---------------- */
  function promise(el) {
    if (el.dataset.ybBooted) return; el.dataset.ybBooted = '1';
    const dict = i18n(el);
    const cutoff = Number(el.dataset.cutoff ?? 14);
    const closed = (el.dataset.closedDays || '').split(',').map(s => s.trim()).filter(Boolean).map(Number);
    const main = el.querySelector('[data-yb-promise-main]'), timer = el.querySelector('[data-yb-promise-timer]');
    const kuwaitNow = () => {
      try {
        const parts = new Intl.DateTimeFormat('en-US', { timeZone: 'Asia/Kuwait', hour: 'numeric', minute: 'numeric', second: 'numeric', weekday: 'short', hour12: false }).formatToParts(new Date());
        const get = type => parts.find(p => p.type === type)?.value;
        const day = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].indexOf(get('weekday'));
        return { day, h: Number(get('hour')) % 24, m: Number(get('minute')), s: Number(get('second')) };
      } catch { const d = new Date(Date.now() + 3 * 3600 * 1000); return { day: d.getUTCDay(), h: d.getUTCHours(), m: d.getUTCMinutes(), s: d.getUTCSeconds() }; }
    };
    const fmtCutoff = () => { const h = cutoff % 12 || 12; return isArabic ? `${h} ${cutoff >= 12 ? 'مساءً' : 'صباحاً'}` : `${h} ${cutoff >= 12 ? 'PM' : 'AM'}`; };
    const tick = () => {
      const now = kuwaitNow();
      const secondsLeft = cutoff * 3600 - (now.h * 3600 + now.m * 60 + now.s);
      if (closed.includes(now.day)) { el.dataset.state = 'closed'; main.textContent = t(dict, 'closed_today'); timer.hidden = true; return; }
      if (secondsLeft > 0) {
        el.dataset.state = 'open';
        main.textContent = t(dict, 'same_day', { time: fmtCutoff() });
        const h = Math.floor(secondsLeft / 3600), m = Math.floor((secondsLeft % 3600) / 60);
        timer.hidden = false; timer.textContent = `${h}${t(dict, 'hours')} ${String(m).padStart(2, '0')}${t(dict, 'minutes')}`;
        timer.setAttribute('aria-label', t(dict, 'countdown', { time: timer.textContent }));
      } else { el.dataset.state = 'closed'; main.textContent = t(dict, 'next_day'); timer.hidden = true; }
    };
    tick(); setInterval(tick, 30000);
  }

  /* ---------------- Boot ---------------- */
  function boot(scope) {
    const q = sel => [...(scope || document).querySelectorAll(sel)];
    q('[data-yb-gift-finder]').forEach(giftFinder);
    compare.bootButtons();
    q('[data-yb-cmp-page]').forEach(compare.page);
    q('[data-yb-drops]').forEach(drops);
    q('[data-yb-reviews]').forEach(reviews);
    q('[data-yb-calc]').forEach(circleCalc);
    q('[data-yb-circle-badge]').forEach(circleBadge);
    q('[data-yb-restock]').forEach(restock);
    q('[data-yb-promise]').forEach(promise);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot()); else boot();
  document.addEventListener('shopify:section:load', e => boot(e.target));
  window.YUBZ = Object.assign(window.YUBZ || {}, { discoverBoot: boot, compare });
})();
